module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__main-remotes--item",
    class: {
      'selected-remote': _vm.active
    },
    on: {
      "click": _vm.toggleSelected
    }
  }, [_c('div', {
    staticClass: "system-builder__main-remotes--item-image"
  }, [_vm._t("remote-image")], 2), _vm._v(" "), _c('div', {
    staticClass: "system-builder__main-remotes--item-content"
  }, [_vm._t("remote-description")], 2), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue"
  }, [_vm._v("Select")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34469afa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/RemoteItem.vue
// module id = 422
// module chunks = 1